import { render } from "./SubNavbar.vue?vue&type=template&id=020fe2f0"
import script from "./SubNavbar.vue?vue&type=script&lang=js"
export * from "./SubNavbar.vue?vue&type=script&lang=js"
script.render = render

export default script